/* eslint-disable consistent-return, default-case, no-param-reassign */
/*
 *
 * Forgot Username reducer
 *
 */

import produce from 'immer';

import {
  CHANGE_INPUT,
  CHANGE_INPUT_ERROR,
  CHANGE_STEP,
  FORGOT_USERNAME_INITIATE,
  FORGOT_USERNAME_INITIATE_FAILURE,
  FORGOT_USERNAME_INITIATE_SUCCESS,
  FORGOT_USERNAME_VERIFY,
  FORGOT_USERNAME_VERIFY_FAILURE,
  FORGOT_USERNAME_VERIFY_SUCCESS,
  RESET_INPUT_ERRORS,
  RESET_STATE,
} from './constants';

export const initialState = {
  error: {
    bannerError: false,
    serviceError: false,
  },
  form: {
    forgotUsername: { email: '' },
    verifyUsername: {
      loanNumber: '',
      ssnTin: '',
      zipCode: '',
    },
  },
  formErrors: {
    forgotUsername: { email: '' },
    verifyUsername: {
      loanNumber: '',
      ssnTin: '',
      zipCode: '',
    },
  },
  recoveredUsername: '',
  status: {
    forgotUsernameInitiate: 'idle',
    forgotUsernameVerify: 'idle',
  },
  step: {
    init: 1,
    verify: 1,
  },
};

const forgotUsernameReducer = produce((draft, { payload, type }) => {
  switch (type) {
    case CHANGE_INPUT: {
      const { field, form, value } = payload;
      draft.form[form][field] = value;
      break;
    }
    case CHANGE_INPUT_ERROR: {
      const { field, form, value } = payload;
      draft.formErrors[form][field] = value;
      break;
    }
    case CHANGE_STEP: {
      const { step, view } = payload;
      draft.step[view] = step;
      break;
    }
    case FORGOT_USERNAME_INITIATE: {
      draft.error = initialState.error;
      draft.status.forgotUsernameInitiate = 'loading';
      break;
    }
    case FORGOT_USERNAME_INITIATE_FAILURE: {
      const { bannerError, error, validationErrors } = payload;
      if (bannerError) {
        draft.error.bannerError = bannerError;
      }
      if (error) {
        draft.error.serviceError = error;
      }
      if (validationErrors) {
        Object.keys(validationErrors).forEach((key) => {
          draft.formErrors.forgotUsername[key] = validationErrors[key];
        });
      }
      draft.status.forgotUsernameInitiate = 'failed';
      break;
    }
    case FORGOT_USERNAME_INITIATE_SUCCESS: {
      draft.status.forgotUsernameInitiate = 'succeeded';
      break;
    }
    case FORGOT_USERNAME_VERIFY: {
      draft.error = initialState.error;
      draft.recoveredUsername = '';
      draft.status.forgotUsernameVerify = 'loading';
      break;
    }
    case FORGOT_USERNAME_VERIFY_FAILURE: {
      const { bannerError, error, validationErrors } = payload;
      if (bannerError) {
        draft.error.bannerError = bannerError;
      }
      if (error) {
        draft.error.serviceError = error;
      }
      if (validationErrors) {
        Object.keys(validationErrors).forEach((key) => {
          draft.formErrors.verifyUsername[key] = validationErrors[key];
        });
      }
      draft.status.forgotUsernameVerify = 'failed';
      break;
    }
    case FORGOT_USERNAME_VERIFY_SUCCESS: {
      const { username } = payload;
      draft.recoveredUsername = username;
      draft.status.forgotUsernameVerify = 'succeeded';
      break;
    }
    case RESET_INPUT_ERRORS: {
      const { field, form } = payload;
      draft.formErrors[form][field] = initialState.formErrors[form][field];
      break;
    }
    case RESET_STATE: {
      return initialState;
    }
  }
}, initialState);

export default forgotUsernameReducer;
